import React from "react";
import "./LearnIntro.css";
import { FaYoutube, FaTwitch } from "react-icons/fa";
import perfilImage from "../images/diegoFotoPerfil.png";
import { useTranslation } from "../i18n";

function LearnIntro() {
    const { t } = useTranslation();

    return (
        <section className="learn-intro">
            <div className="intro-content">
                <img 
                    src={perfilImage}
                    alt="Perfil de TheQAHub" 
                    className="profile-img"
                />
                <h2>
                    <span className="learn-intro-title-prefix">{t("learn.introTitlePrefix")}</span>
                    <span className="learn-intro-title-brand" translate="no">{"</"}TheQAHub{">"}</span>
                </h2>
                <p>
                    {t("learn.introP1")}
                </p>
                <p>
                    {t("learn.introP2")}
                </p>
                <div className="social-buttons">
                    <a href="https://www.youtube.com/@theqahub_es" target="_blank" rel="noreferrer" className="youtube-btn">
                        <span className="social-icon-wrap">
                            <FaYoutube />
                        </span>
                        <span className="social-copy">
                            <strong>{t("learn.youtubeLabel")}</strong>
                            <small>{t("learn.youtubeSubtitle")}</small>
                        </span>
                    </a>
                    <a href="https://www.twitch.tv/TheQAHub" target="_blank" rel="noreferrer" className="twitch-btn">
                        <span className="social-icon-wrap">
                            <FaTwitch />
                        </span>
                        <span className="social-copy">
                            <strong>{t("learn.twitchLabel")}</strong>
                            <small>{t("learn.twitchSubtitle")}</small>
                        </span>
                    </a>
                </div>
            </div>
        </section>
    );
}

export default LearnIntro;
